import { CRUDProvider } from 'components/providers';
import { useTranslation } from 'react-i18next';
import { SpotlightResources } from 'services/resources/spotlight';

import { Page } from './components/Page';

export const SpotlightPage: React.FC = (): JSX.Element => {
  const { t } = useTranslation('spotlight');

  return (
    <CRUDProvider
      allowPost
      quote={t('page.quote')}
      resource={SpotlightResources}
      title={t('page.title')}
    >
      <Page />
    </CRUDProvider>
  );
};
